<template>
  <MainLayout>
    <div class="rules-container">
      <h2>Regulamento</h2>

      <p v-if="pdfUrl && !pdfLoaded" style="margin-top: 8px; text-align: center;">Carregando regulamento...</p>

      <iframe ref="pdfViewer" v-if="pdfUrl" :src="pdfUrl" style="width: 100%; height: 70vh;" frameborder="0"
        v-on:load="checkIfPdfIsLoaded"></iframe>
      <div v-else class="content" v-html="campaign.rules"></div>

    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "../layout/main";
import CampaignMixin from "../mixins/campaign.mixin.js";

export default {
  mixins: [CampaignMixin],
  components: {
    MainLayout,
  },
  data: function () {
    return {
      style: {},
      userLogin: "",
      userEdit: "",
      pdfUrl: '',
      pdfLoaded: false,
    };
  },
  watch: {
    campaign(newValue) {
      // console.log("Campanha - Atualizada " + newValue);
      this.userLogin = `${newValue}/user/login`;
      this.userEdit = `${newValue}/user`;
      // console.log("campanha identificada");
      this.$forceUpdate();
    },
  },
  mounted() {
    if (this.campaign?.rules_file?.url) {
      this.pdfUrl = `https://docs.google.com/gview?url=${this.campaign.rules_file.url}&embedded=true`
    }
  },
  methods: {
    doNothing() { },
    loadPdf() {
      if (this.pdfLoaded) {
        clearTimeout(timeoutPdf)
        return
      }

      console.log("pdfLoaded", this.pdfLoaded)
      const iframe = this.$refs.pdfViewer;
      iframe.src = this.pdfUrl;

      if (iframe) {
        const iframeDoc = iframe.contentDocument;

        if (iframeDoc?.body?.innerHTML.trim() === '') {
          console.log('O conteúdo do iframe está vazio')
          this.pdfLoaded = false
        } else this.pdfLoaded = true
      }

      const timeoutPdf = setTimeout(this.loadPdf, 1000)
    },
    checkIfPdfIsLoaded() {
      const iframe = this.$refs.pdfViewer
      if (iframe.contentWindow !== null) {
        this.pdfLoaded = true
        console.log("PDF carregado")
      }
    },
  },
};
</script>

<style lang="scss">
@import "../scss/colors.scss";

.rules-container {
  position: relative;
  overflow-y: scroll;
  padding-bottom: 80px;
  display: block;
  height: 100%;
  padding: 20px 15px;
  padding-bottom: 90px;

  h2 {
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 30px;
  }

}

@media only screen and (max-width: 800px) {
  .rules-container {

    h2 {
      font-size: 1.2rem;
    }

  }
}
</style>